module.exports = __webpack_public_path__ + "img/32.abc255ab.jpg";